import React from 'react';
import {NavItems, NavLang} from './';

import './Nav.scss';

export const Nav = () => {
  return (
    <nav className="nav">
      <NavItems />
      <NavLang />
    </nav>
  );
};
